import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IClienteTable } from '../../models/ICliente';
import { IFormError, IFormProps } from '../utils';
import { validateCnpj } from '../../../utils/validations/cnpj';
import { validateIp } from '../../../utils';
import { IProdutoConsumo, IVendedor } from '../../models';

interface ICreateClienteFormFields {
  cnpj: string
  razaoSocial: string
  nomeFantasia?: string
  login: string
  vendedorId: number
  ProdutosTiposConsumos: {
    IdProduto: number
    IdTipoConsumo: number[]
  }[]
}

interface IEditClienteFormFields {
  id: string
  cnpj: string
  razaoSocial: string
  nomeFantasia?: string
  login: string
  vendedorId: number
  Ativo: boolean
  vendedorLogin: string

  ProdutosTiposConsumos: {
    IdProduto: number
    IdProdutoCliente?: number
    IdTipoConsumo: number
    TipoConsumoAtivo?: boolean
  }[]
}

interface IVincularIPClienteFormFields {
  clienteId: string
  ips: string[]
  ipValue?: string
}

// interface para lista de clientes

interface IGetClientesList {
  clientes: IClienteTable[],

}

// constante de initial state da interface

const getClientesListInitialState: IGetClientesList = {
  clientes: []
}

const createClienteFormFieldsInitialState: ICreateClienteFormFields = {
  cnpj: '',
  login: '',
  razaoSocial: '',
  vendedorId: -1,
  nomeFantasia: '',
  ProdutosTiposConsumos: []
}

const editClienteFormFieldsInitialState: IEditClienteFormFields = {
  id: '',
  cnpj: '',
  login: '',
  razaoSocial: '',
  vendedorId: 0,
  vendedorLogin: '',
  Ativo: false,
  ProdutosTiposConsumos: []
}

const vincularIPClienteFormFieldsInitialState: IVincularIPClienteFormFields = {
  clienteId: '',
  ips: [],
  ipValue: ''
}

export const validateCreateClienteForm = (fields: ICreateClienteFormFields): IFormError<keyof ICreateClienteFormFields>[] => {
  const errors: IFormError<keyof ICreateClienteFormFields>[] = [];

  /* Validate Email */
  if (fields.cnpj === '') {
    errors.push({
      key: 'cnpj',
      message: 'CNPJ é obrigatório'
    })
  } else {
    const isCNPJValid = validateCnpj(fields.cnpj)
    if (!isCNPJValid) {
      errors.push({
        key: 'cnpj',
        message: 'CNPJ inválido'
      })
    }
  }

  if (fields.razaoSocial === '') {
    errors.push({
      key: 'razaoSocial',
      message: 'Razão Social é obrigatório'
    })
  }

  if (fields.login === '') {
    errors.push({
      key: 'login',
      message: 'Login é obrigatório'
    })
  }

  if (fields.vendedorId === -1) {
    errors.push({
      key: 'vendedorId',
      message: 'Vendedor é obrigatório'
    })
  }

  return errors
}

export const validateEditClienteForm = (fields: IEditClienteFormFields): IFormError<keyof IEditClienteFormFields>[] => {
  const errors: IFormError<keyof IEditClienteFormFields>[] = [];

  /* Validate Email */
  if (fields.cnpj === '') {
    errors.push({
      key: 'cnpj',
      message: 'CNPJ é obrigatório'
    })
  } else {
    const isCNPJValid = validateCnpj(fields.cnpj)
    if (!isCNPJValid) {
      errors.push({
        key: 'cnpj',
        message: 'CNPJ inválido'
      })
    }
  }

  if (fields.razaoSocial === '') {
    errors.push({
      key: 'razaoSocial',
      message: 'Razão Social é obrigatório'
    })
  }

  if (fields.login === '') {
    errors.push({
      key: 'login',
      message: 'Login é obrigatório'
    })
  }

  if (fields.vendedorId === 0) {
    errors.push({
      key: 'vendedorId',
      message: 'Vendedor é obrigatório'
    })
  }

  return errors
}

export const validateVincularIPClienteForm = (fields: IVincularIPClienteFormFields): IFormError<keyof IVincularIPClienteFormFields>[] => {
  const errors: IFormError<keyof IVincularIPClienteFormFields>[] = [];

  if (fields.ipValue === '' || fields.ipValue === undefined) {
    errors.push({
      key: 'ipValue',
      message: 'IP é obrigatório'
    })
  } else {
    const isIPValid = validateIp(fields.ipValue)
    if (!isIPValid) {
      errors.push({
        key: 'ipValue',
        message: 'IP inválido'
      })
    }
  }

  return errors
}
// const mockCliente: IClienteTable = {
//   IdCliente: 1,
//   RazaoSocial: "-",
//   NomeFantasia: "-",
//   LoginCliente: "-",
//   CNPJ: "-",
//   Ativo: true,
//   Inclusao: new Date(),
//   Atualizacao: null,
//   // LoginUsuarioVendedor: "-",
//   TotalLinhas: 10,
//   IdVendedor: 0
// };
interface IClientesState {
  clientes: IClienteTable[],
  total?: number
  clienteListFiltros: {
    searchIdCliente?: number,
    searchIdUsuario?: number,
    searchCNPJ?: string
    searchRazaoSocial?: string
    searchNomeFantasia?: string
    searchLoginCliente?: string
    searchInclusaoMaxima?: Date
    searchInclusaoMinima?: Date
    usuario?: number
    searchIdVendedor?: number
  }
  clientesPagination: {
    page: number
    limit: number
  }
  createClienteForm: IFormProps<ICreateClienteFormFields>
  editClienteForm: IFormProps<IEditClienteFormFields>
  vincularIPClienteForm: IFormProps<IVincularIPClienteFormFields>
  clienteIdVincularProduto: string
  produtoConsumoVinculados: IProdutoConsumo[]
  vendedores: IVendedor[]
  getClientesList: IFormProps<IGetClientesList>
}

const initialState: IClientesState = {
  clienteIdVincularProduto: '',
  produtoConsumoVinculados: [],
  clientes: [],
  total: 0,

  clientesPagination: {
    page: 1,
    limit: 10,
  },
  createClienteForm: {
    errors: [],
    fields: createClienteFormFieldsInitialState,
    touched: false,
    delivered: false
  },
  editClienteForm: {
    errors: [],
    fields: editClienteFormFieldsInitialState,
    touched: false,
    delivered: false
  },
  vincularIPClienteForm: {
    errors: [],
    fields: vincularIPClienteFormFieldsInitialState,
    touched: false,
    delivered: false
  },
  vendedores: [],
  getClientesList: {
    errors: [],
    fields: getClientesListInitialState,
    touched: false,
    delivered: false
  },
  clienteListFiltros: {
    searchIdCliente: 1,
    searchIdUsuario: 0,
    searchCNPJ: '',
    searchRazaoSocial: '',
    searchNomeFantasia: '',
    searchLoginCliente: '',
    searchInclusaoMaxima: undefined,
    searchInclusaoMinima: undefined,
    usuario: 0,
    searchIdVendedor: undefined
  }
};

const clientesSlice = createSlice({
  name: 'Clientes',
  initialState,
  reducers: {
    // Lists Actions
    setClientesState(state, action: PayloadAction<{
      clientes: IClienteTable[],
      total: number
    }>) {
      state.clientes = action.payload.clientes;
      state.total = action.payload.total
    },
    resetClientesState(state) {
      state.clientes = initialState.clientes
      state.total = initialState.total
    },
    // setFiltrosClientesState(state, action: PayloadAction<{
    //   searchIdCliente?: number,
    //   searchIdUsuario?: number,
    //   searchCNPJ?: string
    //   searchRazaoSocial?: string
    //   searchNomeFantasia?: string
    //   searchLoginCliente?: string
    //   searchInclusaoMaxima?: Date
    //   searchInclusaoMinima?: Date
    //   usuario?: number
    //   idVendedor?: number
    // }>) {
    //   state.clienteListFiltros = {
    //     ...state.clienteListFiltros,
    //     ...action.payload,
    //   };
    // },

    setFiltrosClientesState(state, action: PayloadAction<{
      searchIdCliente: number,
      searchIdUsuario: number,
      searchCNPJ?: string
      searchRazaoSocial?: string
      searchNomeFantasia?: string
      searchLoginCliente?: string
      searchInclusaoMaxima?: Date
      searchInclusaoMinima?: Date
      usuario?: number
      idVendedor?: number
    }>) {

      state.clienteListFiltros.searchIdCliente = action.payload.searchIdCliente;
      state.clienteListFiltros.searchIdUsuario = action.payload.searchIdUsuario;
      state.clienteListFiltros.searchCNPJ = action.payload.searchCNPJ || '';
      state.clienteListFiltros.searchRazaoSocial = action.payload.searchRazaoSocial || '';
      state.clienteListFiltros.searchNomeFantasia = action.payload.searchNomeFantasia || '';
      state.clienteListFiltros.searchLoginCliente = action.payload.searchLoginCliente || '';
      state.clienteListFiltros.searchInclusaoMaxima = action.payload.searchInclusaoMaxima || new Date();
      state.clienteListFiltros.searchInclusaoMinima = action.payload.searchInclusaoMinima || new Date();
      state.clienteListFiltros.usuario = action.payload.usuario || 0;
      state.clienteListFiltros.searchIdVendedor = action.payload.idVendedor || 0;
    },

    setClientesTotalState(state, action: PayloadAction<{
      clientes: IClienteTable[],
      total: number
    }>) {
      state.total = action.payload.clientes[0]?.TotalLinhas || 0
    },
    setClientesPaginationState(state, action: PayloadAction<{
      page: number
      limit: number
    }>) {
      state.clientesPagination = {
        page: action.payload.page,
        limit: action.payload.limit
      }
    },
    setClientePageState(state, action: PayloadAction<{
      page: number
    }>) {
      state.clientesPagination.page = action.payload.page
    },
    setClienteLimitState(state, action: PayloadAction<{
      limit: number
    }>) {
      state.clientesPagination.limit = action.payload.limit
    },
    setVendedoresState(state, action: PayloadAction<{
      vendedores: IVendedor[]
    }>) {
      state.vendedores = action.payload.vendedores
    },
    // Vincular Produto Cliente Form Actions
    setClienteIdVincularProdutoState(state, action: PayloadAction<{
      clienteId: string
    }>) {
      state.clienteIdVincularProduto = action.payload.clienteId
    },
    setProdutosVinculadosState(state, action: PayloadAction<{
      produtos: IProdutoConsumo[]
    }>) {
      state.produtoConsumoVinculados = action.payload.produtos
    },

    // Create Cliente Form Actions
    setCreateClienteFormCnpjState(state, action: PayloadAction<{
      cnpj: string
    }>) {
      state.createClienteForm.fields.cnpj = action.payload.cnpj
    },
    setCreateClienteFormRazaoSocialState(state, action: PayloadAction<{
      razaoSocial: string
    }>) {
      state.createClienteForm.fields.razaoSocial = action.payload.razaoSocial
    },
    setCreateClienteFormNomeFantasiaState(state, action: PayloadAction<{
      nomeFantasia: string
    }>) {
      state.createClienteForm.fields.nomeFantasia = action.payload.nomeFantasia
    },
    setCreateClienteFormLoginState(state, action: PayloadAction<{
      login: string
    }>) {
      state.createClienteForm.fields.login = action.payload.login
    },
    setCreateClienteFormVendedorIdState(state, action: PayloadAction<{
      vendedorId: number
    }>) {
      state.createClienteForm.fields.vendedorId = action.payload.vendedorId
    },
    setCreateClienteFormTouchedState(state, action: PayloadAction<{
      touched: boolean
    }>) {
      state.createClienteForm.touched = action.payload.touched
    },
    setCreateClienteFormDeliveredState(state, action: PayloadAction<{
      delivered: boolean
    }>) {
      state.createClienteForm.delivered = action.payload.delivered
    },
    setCreateClienteFormErrorsState(state, action: PayloadAction<{
      errors: IFormProps<ICreateClienteFormFields>['errors']
    }>) {
      state.createClienteForm.errors = action.payload.errors
    },
    resetCreateClienteFormState(state) {
      state.createClienteForm = {
        errors: [],
        fields: createClienteFormFieldsInitialState,
        touched: false,
        delivered: false
      }
    },
    // Edit Cliente Form Actions

    setEditClienteFormIdState(state, action: PayloadAction<{
      id: string
    }>) {
      state.editClienteForm.fields.id = action.payload.id
    },
    setEditClienteFormCnpjState(state, action: PayloadAction<{
      cnpj: string
    }>) {
      state.editClienteForm.fields.cnpj = action.payload.cnpj
    },
    setEditClienteFormRazaoSocialState(state, action: PayloadAction<{
      razaoSocial: string
    }>) {
      state.editClienteForm.fields.razaoSocial = action.payload.razaoSocial
    },
    setEditClienteFormNomeFantasiaState(state, action: PayloadAction<{
      nomeFantasia?: string
    }>) {
      state.editClienteForm.fields.nomeFantasia = action.payload.nomeFantasia
    },
    setEditClienteFormLoginState(state, action: PayloadAction<{
      login: string
    }>) {
      state.editClienteForm.fields.login = action.payload.login
    },
    setEditClienteFormVendedorIdState(state, action: PayloadAction<{
      vendedorId: number
    }>) {
      state.editClienteForm.fields.vendedorId = action.payload.vendedorId
    },
    setEditClienteFormVendedorNomeState(state, action: PayloadAction<{
      LoginUsuarioVendedor: string
    }>) {
      state.editClienteForm.fields.vendedorLogin = action.payload.LoginUsuarioVendedor
    },
    setEditClienteFormStatusState(state, action: PayloadAction<{
      status: boolean
    }>) {
      state.editClienteForm.fields.Ativo = action.payload.status
    },
    setEditClienteFormTouchedState(state, action: PayloadAction<{
      touched: boolean
    }>) {
      state.editClienteForm.touched = action.payload.touched
    },
    setEditClienteFormDeliveredState(state, action: PayloadAction<{
      delivered: boolean
    }>) {
      state.editClienteForm.delivered = action.payload.delivered
    },
    setEditClienteFormErrorsState(state, action: PayloadAction<{
      errors: IFormProps<IEditClienteFormFields>['errors']
    }>) {
      state.editClienteForm.errors = action.payload.errors
    },
    resetEditClienteFormState(state) {
      state.editClienteForm = {
        errors: [],
        fields: editClienteFormFieldsInitialState,
        touched: false,
        delivered: false
      }
    },

    setVincularProdutoEditClienteFormFieldsState(state, action: PayloadAction<{
      idProduto: number
    }>) {
      if (state.createClienteForm.fields.ProdutosTiposConsumos.filter((produtoTipoConsumo) => produtoTipoConsumo.IdProduto === action.payload.idProduto).length === 0) {
        state.createClienteForm.fields.ProdutosTiposConsumos.push({
          IdProduto: action.payload.idProduto,
          IdTipoConsumo: [],
          // todosSelecionados: false
        })
      }
    },

    removeProdutoEditClienteFormFieldsState(state, action: PayloadAction<{
      idProduto: number
    }>) {
      state.editClienteForm.fields.ProdutosTiposConsumos = state.editClienteForm.fields.ProdutosTiposConsumos.filter((produtoTipoConsumo) => produtoTipoConsumo.IdProduto !== action.payload.idProduto)
    },

    setVincularTipoConsumoEditClienteFormFieldsState(state, action: PayloadAction<{ idProduto: number, idTipoConsumo: number }>) {
      const produtoConsumo = state.editClienteForm.fields.ProdutosTiposConsumos.find((produtoTipoConsumo) => {
        return produtoTipoConsumo.IdProduto === action.payload.idProduto &&
          produtoTipoConsumo.IdTipoConsumo === action.payload.idTipoConsumo;
      });
      if (produtoConsumo) {

        state.editClienteForm.fields.ProdutosTiposConsumos = state.editClienteForm.fields.ProdutosTiposConsumos.filter((produtoTipoConsumo) => {
          return produtoTipoConsumo.IdProduto !== action.payload.idProduto &&
            produtoTipoConsumo.IdTipoConsumo !== action.payload.idTipoConsumo;
        });
      } else {
        state.editClienteForm.fields.ProdutosTiposConsumos.push({
          IdProduto: action.payload.idProduto,
          IdTipoConsumo: action.payload.idTipoConsumo,
          TipoConsumoAtivo: true
        });
      }
    },

    removeTipoConsumoEditClienteFormFieldsState(state, action: PayloadAction<{ idProduto: number, idTipoConsumo: number }>) {
      const { idProduto, idTipoConsumo } = action.payload;
      state.editClienteForm.fields.ProdutosTiposConsumos =
        state.editClienteForm.fields.ProdutosTiposConsumos.filter(
          (item) => !(item.IdProduto === idProduto && item.IdTipoConsumo === idTipoConsumo)
        );
    },

    setEditClienteFormProdutosTipoConsumoState(state, action: PayloadAction<{
      ProdutosTiposConsumos: {
        IdProduto: number
        IdProdutoCliente?: number
        IdTipoConsumo: number
        TipoConsumoAtivo?: boolean
      }[]
    }>) {
      state.editClienteForm.fields.ProdutosTiposConsumos = action.payload.ProdutosTiposConsumos
    },

    resetTipoConsumoEditClienteFormFieldsState(state, action: PayloadAction<{
      idProduto: number
    }>) {
      state.editClienteForm.fields.ProdutosTiposConsumos.map((produtosTipoConsumo) => {
        if (produtosTipoConsumo.IdProduto === action.payload.idProduto) {
          produtosTipoConsumo.IdTipoConsumo = 0
        }
      })
    },

    // Vincular IP Cliente Form Actions
    setVincularIPClienteFormClienteIdState(state, action: PayloadAction<{
      clienteId: string
    }>) {
      state.vincularIPClienteForm.fields.clienteId = action.payload.clienteId
    },
    setVincularIPClienteFormIpsState(state, action: PayloadAction<{
      ips: string[]
    }>) {
      state.vincularIPClienteForm.fields.ips = action.payload.ips
    },
    setVincularIPClienteFormIpValueState(state, action: PayloadAction<{
      ipValue: string
    }>) {
      state.vincularIPClienteForm.fields.ipValue = action.payload.ipValue
    },
    setVincularIPClienteFormTouchedState(state, action: PayloadAction<{
      touched: boolean
    }>) {
      state.vincularIPClienteForm.touched = action.payload.touched
    },
    setVincularIPClienteFormDeliveredState(state, action: PayloadAction<{
      delivered: boolean
    }>) {
      state.vincularIPClienteForm.delivered = action.payload.delivered
    },
    setVincularIPClienteFormErrorsState(state, action: PayloadAction<{
      errors: IFormProps<IVincularIPClienteFormFields>['errors']
    }>) {
      state.vincularIPClienteForm.errors = action.payload.errors
    },
    resetVincularIPClienteFormState(state) {
      state.vincularIPClienteForm = {
        errors: [],
        fields: vincularIPClienteFormFieldsInitialState,
        touched: false,
        delivered: false
      }
    },
    setVincularProdutoCreateClienteFormFieldsState(state, action: PayloadAction<{
      idProduto: number
    }>) {
      if (!state.createClienteForm.fields.ProdutosTiposConsumos.some(
        (produto) => produto.IdProduto === action.payload.idProduto
      )) {
        state.createClienteForm.fields.ProdutosTiposConsumos.push({
          IdProduto: action.payload.idProduto,
          IdTipoConsumo: []
        });
      }
    },
    removeProdutoCreateClienteFormFieldsState(state, action: PayloadAction<{
      idProduto: number
    }>) {
      state.createClienteForm.fields.ProdutosTiposConsumos =
        state.createClienteForm.fields.ProdutosTiposConsumos.filter(
          (produto) => produto.IdProduto !== action.payload.idProduto
        );
    },

    setVincularTipoConsumoCreateClienteFormFieldsState(state, action: PayloadAction<{
      idProduto: number,
      idTipoConsumo: number
    }>) {
      const produto = state.createClienteForm.fields.ProdutosTiposConsumos.find(
        (produto) => produto.IdProduto === action.payload.idProduto
      );

      if (produto && !produto.IdTipoConsumo.includes(action.payload.idTipoConsumo)) {
        produto.IdTipoConsumo.push(action.payload.idTipoConsumo);
      }
    },


    removeTipoConsumoCreateClienteFormFieldsState(state, action: PayloadAction<{
      idProduto: number,
      idTipoConsumo: number
    }>) {
      const produto = state.createClienteForm.fields.ProdutosTiposConsumos.find(
        (produto) => produto.IdProduto === action.payload.idProduto
      );

      if (produto) {
        produto.IdTipoConsumo = produto.IdTipoConsumo.filter(
          (id) => id !== action.payload.idTipoConsumo
        );
      }
    },

    resetTipoConsumoCreateClienteFormFieldsState(state, action: PayloadAction<{
      idProduto: number
    }>) {
      state.createClienteForm.fields.ProdutosTiposConsumos.map((produtosTipoConsumo) => {
        if (produtosTipoConsumo.IdProduto === action.payload.idProduto) {
          produtosTipoConsumo.IdTipoConsumo = []
        }
      })
    },
    setVincularSelecionarTudoCreateClienteFormFieldsState(state, action: PayloadAction<{
      todosSelecionados: boolean
      idProduto: number
    }>) {
      const findProdutoSelecionado = state.createClienteForm.fields.ProdutosTiposConsumos.find(produtoSelecionado => produtoSelecionado.IdProduto === action.payload.idProduto)
      if (findProdutoSelecionado) {
        const index = state.createClienteForm.fields.ProdutosTiposConsumos.indexOf(findProdutoSelecionado)
        state.createClienteForm.fields.ProdutosTiposConsumos.splice(index, 1)

        state.createClienteForm.fields.ProdutosTiposConsumos.push({
          ...findProdutoSelecionado,
          // todosSelecionados: action.payload.todosSelecionados
        })
      }
    },

    setClienteListFiltrosSearchNomeFantasiaState(state, action: PayloadAction<{
      clientes: IClienteTable[],
      Pagination: {
        page: number
        limit: number
      }
    }>) {
      // state.clienteListFiltros.usuario = action.payload.idUsuario;
      // state.clienteListFiltros.searchCnpj = action.payload.searchCnpj;
      // state.clienteListFiltros.searchRazaoSocial = action.payload.searchRazaoSocial;
      // state.clienteListFiltros.searchNomeFantasia = action.payload.NomeFantasia;
      // state.clienteListFiltros.searchLoginCliente = action.payload.searchLoginCliente;
      // state.clienteListFiltros.idVendedor = action.payload.idVendedor;
      // state.clienteListFiltros.inclusaoMaxima = action.payload.inclusaoMaxima;
      // state.clienteListFiltros.inclusaoMinima = action.payload.inclusaoMinima;

    },

    setClienteListFiltrosSearchState(state, action: PayloadAction<{
      SearchCNPJ: string;
      SearchRazaoSocial: string;
      SearchNomeFantasia: string;
      SearchLoginCliente: string;
      SearchInclusaoMaxima: Date;
      SearchInclusaoMinima: Date;
      SearchIdUsuario: number;
      SearchIdVendedor: number;
      SearchIdCliente: number;
    }>) {
      state.clienteListFiltros.usuario = action.payload.SearchIdUsuario;
      state.clienteListFiltros.searchCNPJ = action.payload.SearchCNPJ;
      state.clienteListFiltros.searchRazaoSocial = action.payload.SearchRazaoSocial;
      state.clienteListFiltros.searchNomeFantasia = action.payload.SearchNomeFantasia;
      state.clienteListFiltros.searchLoginCliente = action.payload.SearchLoginCliente;
      state.clienteListFiltros.searchIdVendedor = action.payload.SearchIdVendedor;
      state.clienteListFiltros.searchInclusaoMaxima = action.payload.SearchInclusaoMaxima;
      state.clienteListFiltros.searchInclusaoMinima = action.payload.SearchInclusaoMinima;
    },

    setProdutosTipoConsumoState(state, action: PayloadAction<IProdutoConsumo[]>) {
      state.produtoConsumoVinculados = action.payload;
    },
  },

});

export const {
  // Lists Actions
  setClientesState,
  resetClientesState,
  setVendedoresState,
  setClientesPaginationState,
  setClientesTotalState,
  setClienteListFiltrosSearchNomeFantasiaState,
  //resetClienteListFiltrosSearchNomeFantasiaState,
  // Vincular Produto Cliente Form Actions
  setClienteIdVincularProdutoState,
  setProdutosVinculadosState,
  // Create Cliente Form Actions
  setCreateClienteFormCnpjState,
  setCreateClienteFormRazaoSocialState,
  setCreateClienteFormNomeFantasiaState,
  setCreateClienteFormLoginState,
  setCreateClienteFormVendedorIdState,
  setCreateClienteFormTouchedState,
  setCreateClienteFormDeliveredState,
  setCreateClienteFormErrorsState,
  resetCreateClienteFormState,
  // Edit Cliente Form Actions
  setEditClienteFormIdState,
  setEditClienteFormCnpjState,
  setEditClienteFormRazaoSocialState,
  setEditClienteFormNomeFantasiaState,
  setEditClienteFormLoginState,
  setEditClienteFormVendedorIdState,
  setEditClienteFormVendedorNomeState,
  setEditClienteFormStatusState,
  setEditClienteFormTouchedState,
  setEditClienteFormDeliveredState,
  setEditClienteFormErrorsState,
  resetEditClienteFormState,
  setEditClienteFormProdutosTipoConsumoState,
  setVincularProdutoEditClienteFormFieldsState,
  removeProdutoEditClienteFormFieldsState,
  resetTipoConsumoEditClienteFormFieldsState,
  setVincularTipoConsumoEditClienteFormFieldsState,

  // Vincular IP Cliente Form Actions
  setVincularIPClienteFormClienteIdState,
  setVincularIPClienteFormIpsState,
  setVincularIPClienteFormIpValueState,
  setVincularIPClienteFormTouchedState,
  setVincularIPClienteFormDeliveredState,
  setVincularIPClienteFormErrorsState,
  resetVincularIPClienteFormState,
  // Vincular tipos de consumo por produto
  setVincularProdutoCreateClienteFormFieldsState,
  removeProdutoCreateClienteFormFieldsState,
  setVincularTipoConsumoCreateClienteFormFieldsState,
  removeTipoConsumoCreateClienteFormFieldsState,
  resetTipoConsumoCreateClienteFormFieldsState,
  setVincularSelecionarTudoCreateClienteFormFieldsState,
  setClienteListFiltrosSearchState,
  setFiltrosClientesState,
  setProdutosTipoConsumoState,
  removeTipoConsumoEditClienteFormFieldsState
} = clientesSlice.actions;


export const clientesReducer = clientesSlice.reducer;